export const NUMBER_ANIMATION_DURATION = 0.4
export const WITHLINE_ANIMATION_DURATION = 0.3
export const TEXT_ANIMATION_DURATION = 0.4



// WEBPACK FOOTER //
// ./src/assets/js/highlight/config.js